var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    typography = _ref.typography,
    spacing = _ref.spacing,
    colors = _ref.colors;
  return {
    generateButtonPaddingLeft: spacing.small,
    generateSolutionsInputPaddingTop: spacing.small,
    generatedSolutionsPaddingTop: spacing.medium,
    instructionsPaddingBottom: spacing.small,
    marginPlusMinusColor: colors.contrasts.grey4570,
    marginPlusMinusWeight: typography.fontWeightBold,
    marginTextPadding: spacing.xSmall,
    sectionHeadingPaddingTop: spacing.large,
    sectionHeadingPaddingBottom: spacing.small
  };
};
export default generateComponentTheme;